module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAqCAYAAADbCvnoAAAABHNCSVQICAgIfAhkiAAAAUJJREFUWIXt1DFOAkEUgOF/iCYUlpudxUZrDkBPZ8EFbKVeDkBPWGqOwQU4AAeg18ZGnR2IFaEBnoWaEIS8ZYNiMX+yxWZeXr5MNmu8RfhHVc4N2C2AtAJIK4C0AkgrgLQCSCuAtAJIK4C0AkgrgLQCSCuAtAJIqwLcA8/nhgALMTwYALml6pcMDHTOIRFhjJDGniezfeATmggZ0PgrjIFu5Ohvvf8st3QN9H7ZMpUNaeyZ7AD3N0+ob4QB0Dq1RGAYu/2fx0HQd7mlbSADohNAHIY0fmN0aEYFAbxcE12uyYB2WYyBUVVIr3KcMlc8b2kBA6B+JKYTOYYFZ49vZukJdAtsn8iaNPZMi+4uBQJ4TWhcfP4imvvOBfqxK4A+dTNLJ7csvUW+nsd5jbuy+0rf0HbvNW5WGzIDyxWkiWNRdtcHmZNUcKNL5nQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train/sort(4).png
// module id = l4C5
// module chunks = 1